import React, { Component } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

const validate = function(history) {
    const isLoggedIn = !!window.localStorage.getItem('Authorization')
    const noLoginPages = ['/login', '/desktop', '/desktopbilling', '/sharing']
    if (!isLoggedIn && !noLoginPages.includes(history.location.pathname)) {
        history.replace(`/login?returnUrl=${history.location.pathname}`)
        return false
    }
    return true
}

/**
 * Higher-order component (HOC) to wrap restricted pages
 */
export function RequireAuth(BaseComponent) {


    class Restricted extends Component {
        constructor(props) {
            super(props)

            this.state = { valid: false }
        }
        componentWillMount() {
            this.checkAuthentication(this.props)
        }
        componentWillReceiveProps(nextProps) {
            if (nextProps.location !== this.props.location) {
                this.checkAuthentication(nextProps)
            }
        }
        checkAuthentication(params) {
            const { history } = params
            const valid = validate(history)
            this.setState({ valid })
        }
        render() {
            const { valid } = this.state
            if (valid) return <BaseComponent {...this.props} />
            else return <div>Invalid Component</div>
        }
    }
    return withRouter(Restricted)
}

/**
 * Higher-order component (HOC) to protect multi user pages
 */
export const RequireAdmin = ComposedComponent =>
    connect(({ auth }) => auth)(
        class extends Component {
            allowedRoles = ['Owner', 'Admin']
            render() {
                const { user } = this.props
                return (
                    user &&
                    this.allowedRoles.includes(user.role.title) && (
                        <ComposedComponent {...this.props} />
                    )
                )
            }
        }
    )
